import _ from 'lodash'
import { updateOldValue } from '../../lib/processPortalRules'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { getValueForMapping } from '../../lib/widgets'

export const waitProcessingPickList = async (isProcessPickListLoad, pickListCurrentRequest, notNeedWait) => {
  if (isProcessPickListLoad) {
    if (_.size(pickListCurrentRequest)) {
      const isWaitLatestRequest = async (attempt) => {
        return new Promise((resolve) => {
          if (attempt >= 15) {
            resolve()
          }
          let isNeedWait = false
          _.each(pickListCurrentRequest, (step, key) => {
            if (window.ftProcessingLoadPickList[key]) {
              if (window.ftProcessingLoadPickList[key].step == 1) {
                delete window.ftProcessingLoadPickList[key]
              } else if (window.ftProcessingLoadPickList[key].step !== step) {
                window.ftProcessingLoadPickList[key].jobs[step] = 'finished'
              } else {
                _.each(window.ftProcessingLoadPickList[key].jobs, (status, index) => {
                  index = parseInt(index)
                  if (status && index != step && status !== 'finished') {
                    isNeedWait = true
                  }
                })
              }
            }
          })
          if (notNeedWait) {
            resolve()
          } else if (isNeedWait) {
            return setTimeout(() => {
              isWaitLatestRequest(attempt + 1).then(resolve)
            }, 500)
          } else {
            resolve()
          }
        })
      }
      await isWaitLatestRequest(0)
      !notNeedWait && console.log('pickListCurrentRequest >>> ', pickListCurrentRequest)
      _.each(pickListCurrentRequest, (step, key) => {
        delete window.ftProcessingLoadPickList[key]
      })
    }
  }
  return true
}

export const recursivePrepareSFMapping = (
  sfList,
  type,
  path,
  widgetsData,
  params,
  isChild = false,
  messages,
  hashCustomActions,
  conf = {}
) => {
  let result = {}
  const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
  _.each(sfList, function (sfItem, uid) {
    let isSmartV = false
    _.each(sfItem.fields, function (field) {
      if (field.group == 'smartv') {
        isSmartV = true
      }
    })
    if (type == 'translate') {
      if (sfItem.isCurrentLangList) {
        if (sfItem.loadingMessage) {
          messages.push(sfItem.loadingMessage)
        }
        let item = {}
        _.each(sfItem.fields, function (field) {
          if (field) {
            let fieldUID = field.group + '#-#' + updateOldValue(field.value)
            item[fieldUID] = getValueForMapping(field, widgetsData, params, conf.index)
            if (field.group === 'param') {
              if (item[fieldUID]) {
                item['prot_' + fieldUID] = params['prot_' + field.value]
              }
            }
          }
        })
        result[uid] = item
      }
    } else if (sfItem.type === type || isChild || (sfItem.type == 'auto_trigger' && isSmartV && type == 'onload')) {
      let item = {}
      let isValidIntegration = true
      
      // For picklists, respect the trigger configuration
      if (sfItem.loadPickList && type === 'onload' && sfItem.processOnCustomButton) {
        // Skip picklists that are configured for user action during onload processing
        isValidIntegration = false
      }
      
      if (isSmartV && !isUserSignIn) {
        isValidIntegration = false
      }
      if (type === 'custom' && !isChild) {
        if (!hashCustomActions || !hashCustomActions[uid]) {
          isValidIntegration = false
        }
      } else if (type === 'trigger' && !isChild) {
        let isUsedFields = false
        _.each(sfItem.fields, function (field) {
          if (path && path === field.value) {
            isUsedFields = true
          }
        })
        if (!isUsedFields) {
          isValidIntegration = false
        }
      }
      if (isValidIntegration) {
        _.each(sfItem.fields, function (field) {
          if (field && isValidIntegration) {
            let fieldUID = field.group + '#-#' + updateOldValue(field.value)
            item[fieldUID] = getValueForMapping(field, widgetsData, params, conf.index)
            if (field.group === 'param') {
              if (item[fieldUID]) {
                item['prot_' + fieldUID] = params['prot_' + field.value]
              }
            }
            if (type === 'trigger' && field.group !== 'params' && field.group !== 'pageParam') {
              if (item[fieldUID] === '' || item[fieldUID] === undefined || item[fieldUID] === null) {
                isValidIntegration = false
              }
            }
          }
        })
      }
      if (isValidIntegration) {
        if (sfItem.childrens) {
          item.childrens = {
            list: recursivePrepareSFMapping(
              sfItem.childrens,
              type,
              path,
              widgetsData,
              params,
              true,
              messages,
              false,
              conf
            ),
          }
        }
        if (sfItem.loadingMessage) {
          messages.push(sfItem.loadingMessage)
        }
        result[uid] = item
      }
    }
  })
  return result
}
